// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"20aff4bd","330":"4868d0fc","788":"8aee8046","925":"7f4f2ddc"}[chunkId] + ".chunk.js";
};